import { DispenserEvent } from '@/features/dispensers/services/schemas.ts';
import { isAfter } from 'date-fns/isAfter';
import { EventType } from '@/features/events/types/EventType.ts';

export function getLastEvent(events: DispenserEvent[]) {
  return events.reduce((latestEvent, event) => {
    if (isAfter(event.eventAt, latestEvent.eventAt)) {
      return event;
    }
    return latestEvent;
  }, events[0]);
}

export function findEventOfType(events: DispenserEvent[], type: EventType) {
  return events.find((ev) => ev.eventType === type);
}
